export const setList = (state, payload) => state.list = payload;
export const setListForUser = (state, payload) => state.listForUser = payload;
export const setApplication = (state, payload) => state.application = payload;
export const setAppUser = (state, payload) => state.appUser = payload;
export const setAppUserState = (state, payload) => state.appUser.state = payload;
export const setStateForApplication = (state, payload) => state.application.state = payload;
export const setAnswerForApplication = (state, payload) => state.application.answer = payload;
export const deleteApplicationUser = (state, id) => state.listForUser = state.listForUser.filter(application => application.id !== id)
export const setAllAppUser = (state, payload) => state.listAllForUser = payload;
export const setTags = (state, payload) => state.tags = payload
